/**
 * Текстовые заметки гостя — только в IndexedDB в браузере, без отправки на сервер.
 */

const DB_NAME = "stihiya_guest_notes";
const DB_VERSION = 1;
const STORE = "notes";

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB недоступен"));
      return;
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
  });
}

/** @returns {Promise<Array<{ id: string, title: string, body: string, updatedAt: string }>>} */
export async function listGuestNotes() {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => {
      const rows = req.result || [];
      rows.sort((a, b) => String(b.updatedAt || "").localeCompare(String(a.updatedAt || "")));
      resolve(rows);
    };
    req.onerror = () => reject(req.error);
  });
}

/** @param {{ id?: string, title: string, body: string }} note */
export async function saveGuestNote(note) {
  const id = note.id && String(note.id).trim() ? note.id : crypto.randomUUID();
  const titleTrim = (note.title || "").trim();
  const row = {
    id,
    title: titleTrim || "Без названия",
    body: note.body || "",
    updatedAt: new Date().toISOString(),
  };
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(row);
    tx.oncomplete = () => resolve(row);
    tx.onerror = () => reject(tx.error);
  });
}

/** @param {string} id */
export async function deleteGuestNote(id) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => resolve(undefined);
    tx.onerror = () => reject(tx.error);
  });
}
